// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__buXFZ","left":"styles_left__22Q0a","desktopActions":"styles_desktopActions__ZUlRH","title":"styles_title__3oR_j"};